export default __webpack_public_path__ + "static/media/billboard.cc9a1da8.png";